module.exports = __webpack_public_path__ + "static/media/rct-session-banner.3e2dffeb.jpg";